import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { FacadeService } from 'src/app/core/services/facade.service';
import { Departement } from 'src/app/shared/models/departement';

@Component({
	selector: 'app-departement-modal-detail',
	templateUrl: './departement-modal-detail.component.html',
	styleUrls: ['./departement-modal-detail.component.scss']
})
export class DepartementModalDetailComponent implements OnInit {
	NAME_PATTERN = '^[^0-9]+$';

	formEdit = new FormGroup({
		name: new FormControl('', [
			Validators.required,
		]),
		code: new FormControl('', [
			Validators.required
		])
	});

	departement: Departement;

	confirmDeleteModalRef: BsModalRef;

	//Boolean empêchant l'utilisateur d'envoyer plusieurs fois le formulaire
	isValidateButtonClicked = false;

	constructor(
		public bsModalRef: BsModalRef,
		private facade: FacadeService,
		private modalService: BsModalService
	) {}

	ngOnInit(): void {
		this.formEdit.setValue({
			name: this.departement ? this.departement.name : null,
			code: this.departement ? this.departement.code : null
		});
	}

	onSubmit() {
		this.isValidateButtonClicked = true;
		this.departement.name = this.formEdit.get('name').value;
		this.departement.code = this.formEdit.get('code').value;
		this.facade.departementService.updateDepartement(this.departement).subscribe({
			next: (succ) => {
				// this.isValidateButtonClicked=false;
				this.bsModalRef.hide();
			},
			error: (err) => {
				this.isValidateButtonClicked = false;
			}
		});
	}

	deleteSpecialty(): void {
		this.facade.departementService
			.deleteDepartement(this.departement.id)
			.subscribe((_) => {
				this.modalService.hide();
				this.bsModalRef.hide();
			});
	}

	openModal(confirmDeleteTemplate: TemplateRef<any>): void {
		this.confirmDeleteModalRef = this.modalService.show(confirmDeleteTemplate);
	}

	delete() {
		this.facade.departementService
			.deleteDepartement(this.departement.id)
			.subscribe({
				next: (succ) => {
					this.modalService.hide();
					this.bsModalRef.hide();
				},
				error: (err) => {
					this.facade.toastService.createHttpErrorToast(
						err.error.message ? err.error.message : '',
						err.status
					);
				}
			});
	}

	get name() {
		return this.formEdit.get('name');
	}
	get code() {
		return this.formEdit.get('code');
	}
}
